import styled from "styled-components";

export const InputField = styled.label`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;

  input,
  .select {
    width: 100% !important;
  }
  input {
    margin: 5px 0;
    height: 32px;
    border-radius: 5px;
  }
  input[type="checkbox"] {
    height: 15px;
  }
  .ant-input-affix-wrapper {
    padding: 0 10px;
    margin: 5px 0;
    input {
      margin: 0;
    }
  }
  input:disabled,
  select:disabled {
    background-color: #0001;
    color: #0009;
    cursor: not-allowed;
  }

  * {
    overflow: hidden;
  }
  &.fieldchckbx {
    display: grid;
    grid-template-columns: 30px 1fr;
    align-items: center;
  }

  @media only screen and (max-width: 1200px) {
    width: 100%;
    justify-content: right;
    margin-right: 0;
    margin-bottom: 15px;
    display: grid;
    grid-template-columns: 30% 70%;
    align-items: center;
  }
  @media only screen and (max-width: 500px) {
    grid-template-columns: none;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    input,
    select {
      width: 100%;
    }
  }
  &.columnFormField {
    width: 100%;
    justify-content: right;
    margin-right: 0;
    margin-bottom: 15px;
    display: grid;
    grid-template-columns: 30% 70%;

    input:disabled,
    select:disabled {
      background-color: #0001;
      color: #0009;
      cursor: not-allowed;
    }

    @media only screen and (max-width: 500px) {
      grid-template-columns: none;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      input,
      select {
        width: 100%;
      }
    }
  }
`;

export const LabelTextWrapper = styled.span`
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: left;
  width: max-content;
  p {
    width: fit-content;
  }

  &.inpcheckbox {
    margin-left: 10px;
    margin-right: 0;
  }
`;

export const RequiredIndicator = styled.strong`
  color: ${({ theme }) => theme.colors.error};
`;
